import React from "react";
import { useFilters } from "../../data/useFilters";
import LayoutOptions from "./LayoutOptions";
import SortOptions from "./SortOptions";
import { HeaderContainer } from "./styles";
import { useConfig } from "../../data/useConfig";

const Header = () => {
  const { areFiltersAvailable, filterDirection } = useConfig();
  const { error, data } = useFilters();

  if (!data?.meta?.results_count || error) return null;

  return (
    <HeaderContainer
      className="bnly-search__header-container"
      filterDirection={filterDirection}
      areFiltersAvailable={areFiltersAvailable}
    >
      <LayoutOptions />
      <SortOptions />
    </HeaderContainer>
  );
};

export default Header;
